import {SetZoom} from '../../models/redux/setZoom'
import {Img} from '../../models/editor/img'
import {ImgText} from '../../models/editor/imgText'
import {ImgHistoryItem} from '../../models/editor/imgHistoryItem'
import {ImgUrl} from '../../models/editor/imgUrl'

export type Interaction = 'dragging' | 'scaling' | 'rotating'

export interface EditorStore {
  imageHistoryPosition: number | null
  imageHistory: ImgHistoryItem[]
  images: Img[]
  printArea: ImgText | undefined
  maskImage: ImgUrl | null
  selectedImageId: string | undefined
  zoom: SetZoom
  interactedImage: {
    interaction: Interaction
    id: string
    innerImageIndex?: number
    type?: 'caption' | 'text' | 'url' | 'masked' //caption az a szöveg, url a kép, masked a grarfika (és az abban lévő is)
  } | null
}

export const initialEditorStore: EditorStore = {
  imageHistoryPosition: null,
  imageHistory: [],
  images: [],
  printArea: undefined,
  maskImage: null,
  selectedImageId: undefined,
  zoom: {
    level: 1,
    translate: {x: 0, y: 0},
  },
  interactedImage: null,
}
